import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { listSalesContractPlans, startSalesContract } from '../../services/salesContractApi';
import '../../styles/StartSalesContractModal.css';

const money = (value) => new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
}).format(Number(value || 0));

const StartSalesContractModal = ({ show, onHide, lead, colaboradores = [], showAlertModal }) => {
  const [plans, setPlans] = useState([]);
  const [planId, setPlanId] = useState('');
  const [loading, setLoading] = useState(false);
  const [implementationOwnerId, setImplementationOwnerId] = useState('');

  useEffect(() => {
    if (!show) return;
    setLoading(true);
    setImplementationOwnerId(lead?.responsavel_id ? String(lead.responsavel_id) : '');
    listSalesContractPlans(lead.id)
      .then(({ data }) => {
        setPlans(data);
        const preferredSlug = lead?.campos_extras?.plano_interesse;
        const preferred = data.find((plan) => plan.slug === preferredSlug)
          || data.find((plan) => plan.is_recommended)
          || data[0];
        setPlanId(preferred ? String(preferred.id) : '');
      })
      .catch(() => showAlertModal('Erro', 'Não foi possível carregar os planos comerciais.', 'danger'))
      .finally(() => setLoading(false));
  }, [show, lead, showAlertModal]);

  const selected = plans.find((plan) => String(plan.id) === planId);

  const handleStart = async () => {
    if (!planId) return;
    setLoading(true);
    try {
      const { data } = await startSalesContract(lead.id, Number(planId), implementationOwnerId ? Number(implementationOwnerId) : null);
      const contractUrl = new URL(`/contratacao/${data.contract.uuid}`, window.location.origin).toString();
      await navigator.clipboard?.writeText(contractUrl);
      window.open(contractUrl, '_blank', 'noopener,noreferrer');
      showAlertModal('Contratação criada', 'O link foi aberto e copiado para a área de transferência.', 'success');
      onHide();
    } catch (error) {
      showAlertModal('Erro', error.response?.data?.message || 'Não foi possível iniciar a contratação.', 'danger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="start-contract-modal">
      <Modal.Header closeButton>
        <div className="start-contract-modal__heading">
          <span className="start-contract-modal__eyebrow">Nova oportunidade</span>
          <Modal.Title>Iniciar contratação</Modal.Title>
          <p>Escolha a melhor opção e gere um link exclusivo para o cliente.</p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="start-contract-modal__lead">
          <span>{lead?.nome?.trim()?.charAt(0)?.toUpperCase() || 'C'}</span>
          <div><small>Contratação para</small><strong>{lead?.nome}</strong></div>
        </div>
        <label className="start-contract-modal__field">
          Selecione o plano
          <select
            value={planId}
            onChange={(event) => setPlanId(event.target.value)}
            disabled={loading}
          >
            {plans.map((plan) => (
              <option key={plan.id} value={plan.id}>
                {plan.name} — {plan.is_lifetime ? 'Vitalício gratuito' : `${money(plan.price)}/mês`}
              </option>
            ))}
          </select>
        </label>
        <label className="start-contract-modal__field mt-3">
          Responsável pela implantação
          <select value={implementationOwnerId} onChange={(event) => setImplementationOwnerId(event.target.value)} disabled={loading}>
            <option value="">Definir depois</option>
            {colaboradores.map((item) => <option key={item.id} value={item.id}>{item.nome}</option>)}
          </select>
        </label>
        {selected && (
          <div className="start-contract-modal__plan">
            <div className="start-contract-modal__plan-title"><span>Plano selecionado</span><strong>{selected.name}</strong></div>
            {selected.is_lifetime ? <p><strong>Vitalício gratuito, sem mensalidade e sem implantação.</strong><br />O cliente deverá abrir o link, preencher os dados e criar sua senha para acessar o sistema. Não haverá cobrança pela Pagar.me.</p> : <div className="start-contract-modal__prices">
              <div><small>Mensalidade</small><strong>{money(selected.price)}<em>/mês</em></strong></div>
              <div><small>Implantação</small><strong>{money(selected.implementation_price)}<em>uma vez</em></strong></div>
            </div>}
            <p>🔒 Os valores serão preservados nesta contratação, mesmo que o plano seja alterado depois.</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={onHide}>Cancelar</button>
        <button type="button" className="btn start-contract-modal__submit" onClick={handleStart} disabled={loading || !planId}>
          {loading ? <><Spinner size="sm" animation="border" /> Gerando link...</> : 'Gerar link de contratação'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default StartSalesContractModal;
